<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Reset template WA`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <p class="m-d-0 f-16 f-regular f-c-black">
                        Template akan dikembalikan ke versi awal bawaan sistem (default). Yakin ingin me-reset template
                        ini?
                    </p>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <SOButton
                        :primary="true"
                        :full="true"
                        :text="'Ya, reset template'"
                        :id="`do-reset-teplate`"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="resetTemplate"
                    />
                    <SOButton
                        :outline="true"
                        :full="true"
                        :text="'Batal'"
                        :id="'batal-reset-teplate'"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="back"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../../store/state";

export default {
    name: "ResetTemplate",
    components: {
        SOSlotModal,
        SOButton,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat.daftar_oulet.edit_template",
            modalId: "modal-panduan-penulisan",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
        }),
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            resetTemplatePesan: `${moduleName}/resetTemplatePesan`,
            getDetailTemplatePesan: `${moduleName}/getDetailTemplatePesan`,
        }),
        async back() {
            await this.$router.push({
                name: this.backLink,
                query: { title: this.$route.query.title, jenisSetting: this.$route.query.jenisSetting },
            });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        resetTemplate() {
            let { jenisSetting, title, idpayload } = this.$route.query;
            let { id_outlet } = this.$route.params;
            this.resetTemplatePesan({ idpayload: this.$route.query.idpayload, idoutlet: id_outlet })
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200 && status) {
                        this.$toast.success(msg);
                        this.getDetailTemplatePesan({ idoutlet: id_outlet, idpayload });
                        this.$router.push({
                            name: "wa_autosender.detail_perangkat.daftar_oulet.edit_template",
                            query: { jenisSetting, title },
                        });
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
    },
};
</script>
